/**
 * Strips a raw handle input down to the characters the backend accepts (lowercase letters, digits,
 * underscore, dot) — mirrors `normalize_handle` in the profiles setup operation. Shared by every
 * handle field so the client-side allow-list can't drift page to page.
 */
export function sanitizeHandle(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9_.]/g, "");
}
